import React from "react";
import ReactApexChart from "react-apexcharts";

class GrowthChart extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            series: [
                {
                    type: 'boxPlot',
                    data: [
                        {
                            x: 'Jan 2015',
                            y: [54, 66, 69, 75, 88]
                        },
                        {
                            x: 'Jan 2016',
                            y: [43, 65, 69, 76, 81]
                        },
                        {
                            x: 'Jan 2017',
                            y: [31, 39, 45, 51, 59]
                        },
                        {
                            x: 'Jan 2018',
                            y: [39, 46, 55, 65, 71]
                        },
                        {
                            x: 'Jan 2019',
                            y: [29, 31, 35, 39, 44]
                        },
                        {
                            x: 'Jan 2020',
                            y: [41, 49, 58, 61, 67]
                        },
                        {
                            x: 'Jan 2021',
                            y: [54, 59, 66, 71, 88]
                        }
                    ]
                }
            ],
            options: {
                chart: {
                    type: 'boxPlot',
                    height: 200,
                    toolbar: {
                        show: false
                    },
                },
                plotOptions: {
                    boxPlot: {
                        colors: {
                            upper: '#a3acba',
                            lower: '#c0c8d2'
                        },
                    }
                },
                grid: {
                    padding: { top: 0, right: 0, bottom: 0, left: -10 },
                    xaxis: {
                        lines: {
                            show: false
                        }
                    },
                    yaxis: {
                        lines: {
                            show: true
                        }
                    },
                },
                yaxis: {
                    labels: {
                        show: false
                    },
                },
                title: {
                    show: false
                },
                xaxis: {
                    labels: {
                        show: false
                    },
                    axisTicks: {
                        show: false,
                    }
                }
            },


        };
    }

    render() {
        return (

            <div id="chart">
                <ReactApexChart options={this.state.options} series={this.state.series} type="boxPlot" height={200} />
            </div>

        );
    }
}

export default GrowthChart